import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Chip,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField
} from '@mui/material';

import {
  KeyboardArrowDownOutlined,
  SearchOutlined
} from '@mui/icons-material';

import {
  menuProps,
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import {
  categoryOptions,
  dateRangeOptions,
  statusConfig,
  statusFilters
} from './data';

import {
  filtersRowSx,
  getStatusChipSx,
  searchSx,
  selectControlSx,
  statusRowSx
} from './PatientDocumentStyles';

const PatientDocumentFilters = ({
  searchText,
  category,
  dateRange,
  statusFilter,
  onSearchChange,
  onCategoryChange,
  onDateRangeChange,
  onStatusChange,
  countByStatus
}) => {
  return (
    <>
      <Box sx={filtersRowSx}>
        <TextField
          size="small"
          placeholder="Search documents..."
          value={searchText}
          onChange={onSearchChange}
          sx={searchSx}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined fontSize="small" />
                </InputAdornment>
              )
            }
          }}
        />

        <FormControl
          size="small"
          sx={selectControlSx}>
          <Select
            value={category}
            onChange={onCategoryChange}
            MenuProps={menuProps}
            IconComponent={KeyboardArrowDownOutlined}
            sx={textFieldSx}>
            {categoryOptions.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={selectControlSx}>
          <Select
            value={dateRange}
            onChange={onDateRangeChange}
            MenuProps={menuProps}
            IconComponent={KeyboardArrowDownOutlined}
            sx={textFieldSx}>
            {dateRangeOptions.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={statusRowSx}>
        {statusFilters.map(item => (
          <Chip
            key={item.key}
            icon={statusConfig[item.key].icon}
            label={`${item.label} (${countByStatus(item.key)})`}
            clickable
            onClick={() => onStatusChange(item.key)}
            sx={getStatusChipSx(
              statusFilter,
              item.key,
              statusConfig[item.key]
            )}
          />
        ))}
      </Box>
    </>
  );
};

PatientDocumentFilters.propTypes = {
  searchText: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  dateRange: PropTypes.string.isRequired,
  statusFilter: PropTypes.string.isRequired,

  onSearchChange: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,

  countByStatus: PropTypes.func.isRequired
};

export default PatientDocumentFilters;